/** CPS values are opaque server-owned strings. Never normalize them. */
export interface CpsCheckout {
  purchaseReference: string
  checkoutFlowId: string
  expiresAt: string
}

export const getCpsCandidate = (asset: unknown, token: unknown) => {
  const value = Array.isArray(asset) ? asset[0] : asset
  if (typeof value !== 'string' || !value || typeof token !== 'string'
    || token.length < 32 || token.length > 128 || token.trim() !== token) return undefined
  return { pathToken: token }
}

/** Only copy the three fields signed by the server. */
export const copyCpsCheckout = (value: any): CpsCheckout | undefined => {
  if (!value || !['purchaseReference', 'checkoutFlowId', 'expiresAt']
    .every(key => typeof value[key] === 'string' && value[key].length > 0)) return undefined
  return {
    purchaseReference: value.purchaseReference,
    checkoutFlowId: value.checkoutFlowId,
    expiresAt: value.expiresAt
  }
}
